import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate } from "react-router-dom";
import request from "../../utils/http";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const JobCodeRateList = () => {
	const navigate = useNavigate();
	const [jobCodeRates, setJobCodeRates] = useState([] as any);

	const loadJobCodeRates = async () => {
		// Fetch a list of job code rates from API
		try {
			const result = await request("GET", "/api/admin/jobcoderate", null);

			if (result.success && result.data) {
				setJobCodeRates(result.data.jobCodeRates);
			}
		} catch (error) {
			console.error("Error loading job code rates:", error); // Debugging
			// Handle error loading job codes.
		}
	};

	useEffect(() => {
		loadJobCodeRates();
	}, []);

	return (
		<Container>
			<ActionHeader>
				<h1>Job Code Rates</h1>

				<Button
					onClick={() => {
						navigate({
							pathname: `/job-code-rate/create`,
						});
					}}
				>
					Create Job Code Rate
				</Button>
			</ActionHeader>
			<hr />
			<StyledTable role="grid" $gridTemplateColumns={"1fr 1fr 1fr"}>
				<StyledTableRow role="row">
					<StyledHeadCell>Rate ($)</StyledHeadCell>
					<StyledHeadCell>Active</StyledHeadCell>
					<StyledHeadCell>Default</StyledHeadCell>
				</StyledTableRow>

				{jobCodeRates &&
					jobCodeRates.map((jobCodeRate: any, i: number) => {
						const striped = i % 2 === 0;

						return (
							<StyledTableRow
								role="row"
								onClick={() => {
									// Navigate to the edit page for the selected job code.
									navigate(`/job-code-rate/edit/${jobCodeRate.id}`);
								}}
							>
								<StyledBodyCell $striped={striped}>
									{jobCodeRate.jobCodeRate}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{jobCodeRate.active ? "Yes" : "No"}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{jobCodeRate.defaultRate ? "Set" : ""}
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};

export default JobCodeRateList;
